<template>
  <div class="order-report-detail">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="workOrderDetail.appTypeDesc"
      left-arrow
      @click-left="goBack"
      fixed
      placeholder
      v-if="!isNativeApp"
    />

    <div class="form-container">
      <!-- 订单信息和申请类型卡片 -->
      <div class="order-info-application-card">
        <!-- 订单信息展示 -->
        <div class="order-info-section">
          <div class="car-info-item">
            <span>订单号</span>
            <span
              class="car-no"
            >{{ taskDetail.orderNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>车牌号</span>
            <span
              class="car-no"
            >{{ taskDetail.carNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>产品类型</span>
            <span
              class="car-no"
            >{{ taskDetail.productCategoryName || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>优惠信息</span>
            <span
              class="car-no"
            >{{ rightRemark || "-" }}</span>
          </div>
        </div>
      </div>
      <div class="records-header">
        工单信息
      </div>
      <div class="order-info-application-card">
        <!-- 订单信息展示 -->
        <div class="order-info-section">
          <div class="car-info-item">
            <span>工单类型</span>
            <span
              class="car-no"
            >{{ workOrderDetail.appTypeDesc || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>工单状态</span>
            <span
              class="car-no"
              :class="['record-status', getStatusClass(workOrderDetail.status)]"
            >{{ workOrderDetail.statusDesc || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>报备时间</span>
            <span
              class="car-no"
            >{{ workOrderDetail.createdTime || "-" }}</span>
          </div>
          <div
            class="car-info-item"
            v-if="[
              WORK_ORDER_APP_TYPE.dispatch
            ].includes(workOrderDetail.appType)"
          >
            <span>改派原因</span>
            <span
              class="car-no"
            >{{ workOrderDetail.content || "-" }}</span>
          </div>
          <div
            class="car-info-item"
            v-if="[
              WORK_ORDER_APP_TYPE.appointment
            ].includes(workOrderDetail.appType)"
          >
            <span>救援时间</span>
            <span
              class="car-no"
            >{{ workOrderDetail.appointmentTime || "-" }}</span>
          </div>
          <div
            class="car-info-item"
            v-if="[
              WORK_ORDER_APP_TYPE.project
            ].includes(workOrderDetail.appType)"
          >
            <span>救援项目</span>
            <span
              class="car-no"
            >{{ workOrderDetail.productSkuName || "-" }}</span>
          </div>
          <template
            v-if="[
              WORK_ORDER_APP_TYPE.address
            ].includes(workOrderDetail.appType)"
          >
            <div
              class="car-info-item"
              v-if="workOrderDetail.rescueStartAddress"
            >
              <span>救援起点</span>
              <span
                class="car-no"
              >{{ workOrderDetail.rescueStartAddress || "-" }}</span>
            </div>
            <div
              class="car-info-item"
              v-if="workOrderDetail.rescueEndAddress"
            >
              <span>救援终点</span>
              <span
                class="car-no"
              >{{ workOrderDetail.rescueEndAddress || "-" }}</span>
            </div>
          </template>
          <template
            v-if="[
              WORK_ORDER_APP_TYPE.order,
              WORK_ORDER_APP_TYPE.other,
              WORK_ORDER_APP_TYPE.bargain
            ].includes(workOrderDetail.appType)"
          >
            <div
              class="car-info-item"
              :class="{ 'block-item': [
                WORK_ORDER_APP_TYPE.bargain
              ].includes(workOrderDetail.appType) }"
            >
              <span>
                {{
                  [
                    WORK_ORDER_APP_TYPE.bargain
                  ].includes(workOrderDetail.appType) ? '议价金额和原因' : '报备内容'
                }}
              </span>
              <span
                class="car-no"
              >{{ workOrderDetail.content || "-" }}</span>
            </div>
            <div
              class="img-box-list"
            >
              <div
                class="img-box"
                v-for="(img, index) in workOrderDetail.fileList"
                :key="index"
                @click="previewImageHandle(index)"
              >
                <img
                  :src="img.fileUrl"
                  srcset=""
                >
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  workOrderDetail
} from '@/common/apiReport.js';
import {
  getTaskDetail,
  getRightRemark
} from '@/common/apiPaic.js';
import {
  WORK_ORDER_APP_TYPE
} from '../common/constant.js';
import { ImagePreview } from 'vant';
import jsApi from '@/common/jsApi';

export default {
  name: 'OrderReportDetail',
  data() {
    return {
      orderNo: '',
      taskNo: '',
      workOrderId: '',
      WORK_ORDER_APP_TYPE,
      workOrderDetail: {},
      taskDetail: {},
      rightRemark: ''
    };
  },
  computed: {
    isNativeApp() {
      return this.$route.name === 'OrderReportAppDetail';
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
    const { workOrderId } = this.$route.query;
    if (workOrderId) {
      this.workOrderId = workOrderId;
    }
    this.init();
  },
  methods: {
    setNavigationBarTitle(title) {
      // 设置标题
      if (this.isNativeApp) {
        jsApi.setNavigationBar({
          title
        });
      }
    },
    init() {
      this.getWorkOrderDetail();
      this.getTaskDetail();
      this.getRightRemark();
    },
    async getWorkOrderDetail() {
      try {
        const data = await workOrderDetail({
          workOrderId: this.workOrderId
        });
        if (data) {
          this.workOrderDetail = data;
          this.setNavigationBarTitle(this.workOrderDetail.appTypeDesc);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    goBack() {
      // 检查是否有上一页可以返回
      if (window.history.length <= 2) {
        // 如果没有上一页或者历史记录为空，直接跳转到OrderReportAppBase页面
        const { orderNo, taskNo } = this.$route.params;
        this.$router.replace({
          name: this.isNativeApp ? 'OrderReportAppBase' : 'OrderReportBase',
          params: {
            orderNo,
            taskNo
          }
        });
      } else {
        // 否则正常返回上一页
        this.$router.go(-1);
      }
    },
    // 获取状态类名
    getStatusClass(status) {
      const classMap = {
        'processing': 'status-processing',
        'pending': 'status-pending',
        'finished': 'status-finished',
        'closed': 'status-closed'
      };
      return classMap[status] || 'status-default';
    },
    previewImageHandle(index) {
      const images = (this.workOrderDetail?.fileList || []).map(item => item.fileUrl);
      ImagePreview({ images, startPosition: index });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-report-detail {
  min-height: 100vh;
  background-color: #f5f5f5;

  ::v-deep{
    .van-nav-bar {
      .van-nav-bar__left {
        .van-icon {
          color: #565656;
        }
      }
    }
  }
}

.form-container {
  padding: 12px;

  .order-info-application-card {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    padding: 16px;

    & + .order-info-application-card {
      margin-top: 12px;
    }
    .order-info-section {
      .car-info-item {
        display: flex;
        font-size: 15px;
        color: #999999;
        letter-spacing: -0.38px;
        text-align: justify;
        font-weight: 400;
        line-height: 21px;

        & + .car-info-item {
          padding-top: 12px;
        }
        &.block-item {
          flex-direction: column;
          span {
            &:first-child {
              flex: none;
              padding-bottom: 12px;
            }
          }
        }
        span {
          &:first-child {
            flex: 0 0 74px;
          }
          & + span {
            color: #383838;
            white-space: pre-line;
            word-break: break-all;
          }
          &.record-status {
            font-size: 15px;
            letter-spacing: -0.38px;
            text-align: justify;
            font-weight: 400;

            &.status-processing {
              color: #5EC360;
            }
            &.status-pending {
              color: #FF8A59;
            }
            &.status-completed,
            &.status-closed,
            &.status-default {
              color: #9e9e9e;
            }
          }
        }
      }
      .img-box-list {
        display: flex;
        flex-wrap: wrap;
        margin: 4px -16px -8px -8px;
        .img-box {
          width: 96px;
          height: 96px;
          margin: 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            background: #f1f1f1;
            border-radius: 8px;
          }
        }
      }
    }
  }
  .records-header {
    font-size: 15px;
    color: #999999;
    letter-spacing: -0.38px;
    text-align: justify;
    font-weight: 400;
    margin: 24px 0 8px;
  }
}

.form-section {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 12px;

  .edit-section {
    padding: 0 16px 16px;
    .edit-box {
      background: #F5F6F7;
      border-radius: 8px;
      padding: 16px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .apointment-info {
        font-size: 15px;
        letter-spacing: -0.38px;
        font-weight: 400;
        line-height: 21px;
        .apointment-info-label {
          color: #787878;
        }
        .apointment-info-value {
          color: #383838;
        }
      }
      .apointment-btn-box {
        font-size: 15px;
        letter-spacing: -0.38px;
        line-height: 21px;
        text-align: right;
        font-weight: 400;
        .apointment-btn {
          color: #3399FF;
        }
      }

      .project-info {
        font-size: 15px;
        color: #383838;
        letter-spacing: -0.38px;
        line-height: 21px;
        font-weight: 400;
      }
      .arrow-icon {
        color: #ccc;
      }

      .address-box {
        width: 100%;
        .address-title {
          font-size: 15px;
          letter-spacing: -0.38px;
          font-weight: 400;
          line-height: 21px;
          padding-bottom: 8px;
          &.color-green {
            color: #5EC360;
          }
          &.color-red {
            color: #F32222;
          }
        }
        .address-content {
          display: flex;
          justify-content: space-between;

          font-size: 15px;
          letter-spacing: -0.38px;
          font-weight: 400;
          line-height: 21px;
          .address-info {
            color: #383838;
          }
          .address-btn-box {
            color: #3399FF;
            margin-left: 12px;
            flex: none;
          }
        }
      }
    }
  }
}

.section-header {
  display: flex;
  align-items: center;
  padding: 16px 16px 8px;

  .header-title {
    font-size: 15px;
    color: #383838;
    letter-spacing: -0.38px;
    line-height: 21px;
    text-align: justify;
    font-weight: 400;
  }
}

.section-textarea {
  padding: 0 16px;
}

.textarea-box {
  background: #FFFFFF;
  border: 1px solid rgba(200,200,200,1);
  border-radius: 8px;
  padding: 12px;
  font-size: 15px;
  color: #383838;
  letter-spacing: -0.38px;
  line-height: 21px;
  font-weight: 400;
}

.shortcut-phrases {
  padding: 4px 16px 16px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .phrase-tag {
    background: #EEEFF0;
    border-radius: 8px;
    padding: 7px 10px;
    margin-right: 12px;
    margin-top: 12px;
    cursor: pointer;
    font-size: 13px;
    color: #383838;
    letter-spacing: -0.33px;
    font-weight: 400;
  }
}

.upload-section {
  .custom-uploader {
    padding: 8px 0 8px 8px;
    ::v-deep {
      .van-uploader__preview {
        margin: 8px;
      }
      .van-uploader__preview-image {
        box-sizing: border-box;
        width: 96px;
        height: 96px;
        background: #f1f1f1;
        border-radius: 8px;
      }
    }
    .img-upload-btn{
      position: relative;

      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      box-sizing: border-box;
      width: 96px;
      height: 96px;
      margin: 8px;
      background-image: url(~@/assets/img/orderReport/icon-uploader.png);

      background-color: #f7f8fa;
      background-repeat:no-repeat;
      background-position: center center;
      background-size: auto 100%;

      .van-icon {
        color: #dcdee0;

        font-size: 24px;
      }
    }
  }
}

.btn-box{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 12px;

  background: #FFFFFF;
  .van-button{
    height: 40px;
    padding: 9px 10px;

    text-align: center;
    letter-spacing: -0.38px;
    line-height: 21px;

    border-radius: 8px;

    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.van-button--default{
      color: #646464;
      border: 1px solid rgba(200,200,200,1);
      background: #FFFFFF;
    }

    &.van-button--info{
      color: #FFFFFF;
      border: 1px solid #3399FF;
      background: #3399FF;
    }
  }
}
</style>
